(function(){
    'use strict';

    angular
        .module('elogbooks.user.my-details')
        .controller('UserMyDetailsEditController', UserMyDetailsEditController);

    UserMyDetailsEditController.inject = [
        'userResponse',
        'crudService',
        '$state'
    ];

    function UserMyDetailsEditController(
        userResponse,
        crudService,
        $state
    ) {
        const vm = this;

        vm.user = angular.copy(userResponse);
        vm.telephoneList = vm.user.contactInformation?.fields?.filter(function(field) {
            return field.type === 'telephone';
        }) || [];

        vm.addTelephone = addTelephone;
        vm.deleteTelephone = deleteTelephone;
        vm.update = updateAction;
        vm.checkTelephone = checkTelephone;

        function addTelephone() {
            vm.telephoneList.push({
                value: null,
                notes: ''
            });
        }

        function checkTelephone(form, index) {
            return form['telephone-' + index].$invalid && form.$submitted;
        }

        function deleteTelephone(index) {
            vm.telephoneList.splice(index, 1);
        }

        function updateAction() {
            // Destructure and pass only needed data from vm.user
            const updateData = {
                name: vm.user.name,
                telephoneList: vm.telephoneList,
                position: vm.user.position
            };

            return crudService.update(
                vm.user.getLink('update-my-details'),
                updateData,
                $state.get('^'),
                $state.get('dashboard'), // Reload dashboard to reload the user initials
                'USER_DETAILS'
            );
        }
    }
})();